import { useEffect } from "react"

type UsePageFocusProps = {
	onFocus?: () => Promise<void>
	onBlur?: () => Promise<void>
}

const usePageFocus = (props: UsePageFocusProps) => {
	const { onFocus, onBlur } = props

	useEffect(() => {
		const handleFocus = async () => {
			await onFocus?.()
		}

		const handleBlur = async () => {
			await onBlur?.()
		}

		window.addEventListener("focus", handleFocus)
		window.addEventListener("blur", handleBlur)

		return () => {
			window.removeEventListener("focus", handleFocus)
			window.removeEventListener("blur", handleBlur)
		}
	}, [onFocus, onBlur])
}

export default usePageFocus
